var ButtonClassType;
(function (ButtonClassType) {
    ButtonClassType["Primary"] = "primary";
    ButtonClassType["Ghost"] = "ghost";
    ButtonClassType["Flat"] = "flat";
    ButtonClassType["Icon"] = "icon";
})(ButtonClassType || (ButtonClassType = {}));
var ButtonSizeCategory;
(function (ButtonSizeCategory) {
    ButtonSizeCategory["Default"] = "default";
    ButtonSizeCategory["Small"] = "small";
    ButtonSizeCategory["Large"] = "large";
})(ButtonSizeCategory || (ButtonSizeCategory = {}));
var ButtonIconSize;
(function (ButtonIconSize) {
    ButtonIconSize["Small"] = "small";
    ButtonIconSize["Medium"] = "medium";
    ButtonIconSize["Large"] = "large";
})(ButtonIconSize || (ButtonIconSize = {}));
var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition || (IconPosition = {}));
var ButtonAlign;
(function (ButtonAlign) {
    ButtonAlign["Left"] = "left";
    ButtonAlign["Center"] = "center";
    ButtonAlign["Right"] = "right";
})(ButtonAlign || (ButtonAlign = {}));
export { ButtonClassType, ButtonSizeCategory, ButtonIconSize, ButtonAlign, IconPosition };
